const questions = [
  // 1 Слайд \\
  {
    questionDesc: "Siapakah presiden pertama Indonesia?",
    answerOptions: [
      {
        answerText: "Joko Widodo",
        answerResult:
          "Presiden pertama Indonesia adalah Soekarno. Monas dibangun atas inisiatif beliau. Ukuran Monas menyiratkan tanggal proklamasi kemerdekaan Indonesia: 17-8-45.",
        result: false,
      },
      {
        answerText: "Suharto",
        answerResult:
          "Presiden pertama Indonesia adalah Soekarno. Monas dibangun atas inisiatif beliau. Ukuran Monas menyiratkan tanggal proklamasi kemerdekaan Indonesia: 17-8-45.",
        result: false,
      },
      {
        answerText: "Soekarno",
        answerResult:
          "Presiden pertama Indonesia adalah Soekarno. Monas dibangun atas inisiatif beliau. Ukuran Monas menyiratkan tanggal proklamasi kemerdekaan Indonesia: 17-8-45.",
        result: true,
      },
      {
        answerText: "Habibie",
        answerResult:
          "Presiden pertama Indonesia adalah Soekarno. Monas dibangun atas inisiatif beliau. Ukuran Monas menyiratkan tanggal proklamasi kemerdekaan Indonesia: 17-8-45.",
        result: false,
      },
    ],
    image: "images/1.jpg",
  },

  // 2 слайд \\
  {
    questionDesc: "Di mana bendera merah putih pertama kali dikibarkan?",
    answerOptions: [
      {
        answerText: "Jakarta",
        answerResult:
          "Peristiwa ini terjadi pada tanggal 17 Agustus 1945 di Jakarta, di kediaman Soekarno. Bendera dijahit oleh istri beliau karena bendera tidak bisa diperoleh di mana pun. Bendera Bu Fatmawati digunakan hingga tahun 1968 sebelum akhirnya digantikan bendera lain. Saat ini, bendera tersebut disimpan di Istana Merdeka.",
        result: true,
      },
      {
        answerText: "Surabaya",
        answerResult:
          "Peristiwa ini terjadi pada tanggal 17 Agustus 1945 di Jakarta, di kediaman Soekarno. Bendera dijahit oleh istri beliau karena bendera tidak bisa diperoleh di mana pun. Bendera Bu Fatmawati digunakan hingga tahun 1968 sebelum akhirnya digantikan bendera lain. Saat ini, bendera tersebut disimpan di Istana Merdeka.",
        result: false,
      },
      {
        answerText: "Yogyakarta",
        answerResult:
          "Peristiwa ini terjadi pada tanggal 17 Agustus 1945 di Jakarta, di kediaman Soekarno. Bendera dijahit oleh istri beliau karena bendera tidak bisa diperoleh di mana pun. Bendera Bu Fatmawati digunakan hingga tahun 1968 sebelum akhirnya digantikan bendera lain. Saat ini, bendera tersebut disimpan di Istana Merdeka.",
        result: false,
      },
      {
        answerText: "Bandung",
        answerResult:
          "Peristiwa ini terjadi pada tanggal 17 Agustus 1945 di Jakarta, di kediaman Soekarno. Bendera dijahit oleh istri beliau karena bendera tidak bisa diperoleh di mana pun. Bendera Bu Fatmawati digunakan hingga tahun 1968 sebelum akhirnya digantikan bendera lain. Saat ini, bendera tersebut disimpan di Istana Merdeka.",
        result: false,
      },
    ],
    image: "images/2.jpg",
  },

  // 3 слайд \\
  {
    questionDesc: "Apa judul lagu kebangsaan Indonesia?",
    answerOptions: [
      {
        answerText: "Indonesia Raya",
        answerResult:
          "Lagu kebangsaan Indonesia adalah Indonesia Raya. Untuk pertama kalinya, lagu ini dikumandangkan pada tahun 1928 selama acara Sumpah Pemuda, sebelum kemerdekaan Indonesia diproklamasikan. Sang pencipta lagu, Wage Rudolf Supratman memainkan melodi lagu ini dengan bantuan biola dan tanpa ada teks apa pun: saat itu ada sensor dari pemerintah Belanda sehingga lagu hanya bisa dibawakan dengan cara seperti ini.",
        result: true,
      },
      {
        answerText: "Tanah Airku",
        answerResult:
          "Lagu kebangsaan Indonesia adalah Indonesia Raya. Untuk pertama kalinya, lagu ini dikumandangkan pada tahun 1928 selama acara Sumpah Pemuda, sebelum kemerdekaan Indonesia diproklamasikan. Sang pencipta lagu, Wage Rudolf Supratman memainkan melodi lagu ini dengan bantuan biola dan tanpa ada teks apa pun: saat itu ada sensor dari pemerintah Belanda sehingga lagu hanya bisa dibawakan dengan cara seperti ini.",
        result: false,
      },
      {
        answerText: "Bagimu Negeri",
        answerResult:
          "Lagu kebangsaan Indonesia adalah Indonesia Raya. Untuk pertama kalinya, lagu ini dikumandangkan pada tahun 1928 selama acara Sumpah Pemuda, sebelum kemerdekaan Indonesia diproklamasikan. Sang pencipta lagu, Wage Rudolf Supratman memainkan melodi lagu ini dengan bantuan biola dan tanpa ada teks apa pun: saat itu ada sensor dari pemerintah Belanda sehingga lagu hanya bisa dibawakan dengan cara seperti ini.",
        result: false,
      },
      {
        answerText: "Garuda di Dadaku",
        answerResult:
          "Lagu kebangsaan Indonesia adalah Indonesia Raya. Untuk pertama kalinya, lagu ini dikumandangkan pada tahun 1928 selama acara Sumpah Pemuda, sebelum kemerdekaan Indonesia diproklamasikan. Sang pencipta lagu, Wage Rudolf Supratman memainkan melodi lagu ini dengan bantuan biola dan tanpa ada teks apa pun: saat itu ada sensor dari pemerintah Belanda sehingga lagu hanya bisa dibawakan dengan cara seperti ini.",
        result: false,
      },
    ],
    image: "images/3.jpg",
  },

  // 4 слайд \\
  {
    questionDesc:
      "Mengapa penduduk Kota Bandung membakar kota mereka sendiri pada tahun 1946?",
    answerOptions: [
      {
        answerText: "Untuk merayakan kemerdekaan",
        answerResult:
          "Para penduduk membakar kota agar kota tidak direbut para penjajah. Peristiwa ini dikenal sebagai Bandung Lautan Api. Stadion di Bandung kemudian pun menyandang sebutan ini. Peristiwa tersebut menjadi simbol keberanian dan tekad bangsa Indonesia untuk memperjuangkan kemerdekaan.",
        result: false,
      },
      {
        answerText: "Agar kota tidak direbut oleh penjajah",
        answerResult:
          "Para penduduk membakar kota agar kota tidak direbut para penjajah. Peristiwa ini dikenal sebagai Bandung Lautan Api. Stadion di Bandung kemudian pun menyandang sebutan ini. Peristiwa tersebut menjadi simbol keberanian dan tekad bangsa Indonesia untuk memperjuangkan kemerdekaan.",
        result: true,
      },
      {
        answerText: "Akibat gempa bumi",
        answerResult:
          "Para penduduk membakar kota agar kota tidak direbut para penjajah. Peristiwa ini dikenal sebagai Bandung Lautan Api. Stadion di Bandung kemudian pun menyandang sebutan ini. Peristiwa tersebut menjadi simbol keberanian dan tekad bangsa Indonesia untuk memperjuangkan kemerdekaan.",
        result: false,
      },
      {
        answerText: "Untuk membangun kota baru",
        answerResult:
          "Para penduduk membakar kota agar kota tidak direbut para penjajah. Peristiwa ini dikenal sebagai Bandung Lautan Api. Stadion di Bandung kemudian pun menyandang sebutan ini. Peristiwa tersebut menjadi simbol keberanian dan tekad bangsa Indonesia untuk memperjuangkan kemerdekaan.",
        result: false,
      },
    ],
    image: "images/4.jpg",
  },

  // 5 слайд \\
  {
    questionDesc:
      "Siapa pahlawan perempuan yang terkenal dengan surat-suratnya dan gagasan-gagasannya mengenai pendidikan untuk kaum perempuan?",
    answerOptions: [
      {
        answerText: "Raden Adjeng Kartini",
        answerResult:
          "Raden Adjeng Kartini dianggap sebagai simbol emansipasi wanita. Beliau mendirikan sekolah dasar untuk anak-anak perempuan pertama di Indonesia, di mana di dalamnya tidak ada diskriminasi berdasarkan status sosial.",
        result: true,
      },
      {
        answerText: "Cut Nyak Dien",
        answerResult:
          "Raden Adjeng Kartini dianggap sebagai simbol emansipasi wanita. Beliau mendirikan sekolah dasar untuk anak-anak perempuan pertama di Indonesia, di mana di dalamnya tidak ada diskriminasi berdasarkan status sosial.",
        result: false,
      },
      {
        answerText: "Dewi Sartika",
        answerResult:
          "Raden Adjeng Kartini dianggap sebagai simbol emansipasi wanita. Beliau mendirikan sekolah dasar untuk anak-anak perempuan pertama di Indonesia, di mana di dalamnya tidak ada diskriminasi berdasarkan status sosial.",
        result: false,
      },
      {
        answerText: "Megawati Soekarnoputri",
        answerResult:
          "Raden Adjeng Kartini dianggap sebagai simbol emansipasi wanita. Beliau mendirikan sekolah dasar untuk anak-anak perempuan pertama di Indonesia, di mana di dalamnya tidak ada diskriminasi berdasarkan status sosial.",
        result: false,
      },
    ],
    image: "images/5.jpg",
  },

  // 6 слайд \\
  {
    questionDesc:
      "Pada tahun 2018, layanan Maxim hadir di Indonesia. Kami menjadikan perjalanan lebih aman. Fungsi-fungsi apa saja di aplikasi yang kamu ketahui?",
    answerOptions: [
      {
        answerText: "Panggilan ke kantor",
        answerResult:
          "Di Maxim, data pengemudi dapat langsung diketahui, mudah pula untuk berbagi rute. Orang-orang terdekat akan mengetahui dengan siapa kamu berada dan di mana lokasi kamu saat itu. Kalau perlu mengirim pesan kepada pengemudi, gunakan obrolan. Kamu dan pengemudi sama-sama tidak bisa melihat nomor telepon satu sama lain.",
        result: false,
      },
      {
        answerText: "Pelacakan perjalanan, obrolan dengan pengemudi",
        answerResult:
          "Di Maxim, data pengemudi dapat langsung diketahui, mudah pula untuk berbagi rute. Orang-orang terdekat akan mengetahui dengan siapa kamu berada dan di mana lokasi kamu saat itu. Kalau perlu mengirim pesan kepada pengemudi, gunakan obrolan. Kamu dan pengemudi sama-sama tidak bisa melihat nomor telepon satu sama lain.",
        result: true,
      },
      {
        answerText: "Fungsi «Saya terlambat ke sekolah»",
        answerResult:
          "Di Maxim, data pengemudi dapat langsung diketahui, mudah pula untuk berbagi rute. Orang-orang terdekat akan mengetahui dengan siapa kamu berada dan di mana lokasi kamu saat itu. Kalau perlu mengirim pesan kepada pengemudi, gunakan obrolan. Kamu dan pengemudi sama-sama tidak bisa melihat nomor telepon satu sama lain.",
        result: false,
      },
      {
        answerText:
          "Menuliskan preferensi order: «Mama bilang hati-hati di perjalanan»",
        answerResult:
          "Di Maxim, data pengemudi dapat langsung diketahui, mudah pula untuk berbagi rute. Orang-orang terdekat akan mengetahui dengan siapa kamu berada dan di mana lokasi kamu saat itu. Kalau perlu mengirim pesan kepada pengemudi, gunakan obrolan. Kamu dan pengemudi sama-sama tidak bisa melihat nomor telepon satu sama lain.",
        result: false,
      },
    ],
    image: "images/6.jpg",
  },
];

export default questions;
